import { render, staticRenderFns } from "./Commu+voice.vue?vue&type=template&id=465ad206"
import script from "./Commu+voice.vue?vue&type=script&lang=js"
export * from "./Commu+voice.vue?vue&type=script&lang=js"
import style0 from "./Commu+voice.vue?vue&type=style&index=0&id=465ad206&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports